export default __webpack_public_path__ + "static/GLECB-5b8b77c1ad57728a51a6e3205d224ab5.woff2";